import { Injectable } from '@angular/core';
import {
  ConfirmPaymentData,
  StripeElements,
  StripeError,
} from '@stripe/stripe-js';

import { StripeFactoryService } from './stripe-factory.service';
import { StripeInstance } from './stripe-instance-class';
import { Observable } from 'rxjs';

@Injectable()
export class StripeService {
  stripe!: StripeInstance;

  constructor(stripeFactoryService: StripeFactoryService) {
    this.stripe = stripeFactoryService.stripe;
  }

  confirmPayment(options: {
    elements: StripeElements;
    confirmParams: ConfirmPaymentData;
  }): Observable<never | { error: StripeError }>;
  confirmPayment(options: any) {
    return this.stripe.confirmPayment(options);
  }
}
